import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import { ThemeProvider, StyleSheetManager } from "styled-components";
import Globalize from "../../../common-deprecated/Globalize";
import getTheme from "../../../common-deprecated/themes/getTheme";
import { type ModelFilterStateType, modelFilterClientStore } from "./redux/store";
import InitializeSalesman from "../../../common-deprecated/InitializeSalesman";
import { renderReact } from "../../../common-deprecated/utils/clientRenderUtils";
import { clearSelectedFilters } from "./utils/localStorage";
import { ModalProvider } from "../../../common-deprecated/containers/ModalProvider";
import { WindowDimensionsProvider } from "../../../common-deprecated/containers/WindowDimensionsProvider";
import { removeLastSlashAndWhiteSpace } from "../../../common-deprecated/utils";
import { shouldForwardProp } from "../../../shared-logic/utils/styledComponentsUtils";

export const getInit =
    (ModelFilter: React.ElementType) =>
    (target: string, props: unknown, initialState: ModelFilterStateType): void => {
        const { commonSettings } = initialState;
        const { country, language, culture, currencyMultiplier } = commonSettings;

        // eslint-disable-next-line camelcase
        __webpack_public_path__ = `${removeLastSlashAndWhiteSpace(commonSettings.resourcePath)}/`;

        // Initialize store, tagging and globalize.
        const store = modelFilterClientStore(initialState, commonSettings.component);
        if (!store.getState().retailerSettings.isRetailerVariant) {
            InitializeSalesman(commonSettings, store);
        }

        // If there are no active filters, reset the local storage
        if (!initialState.modelFilters.hasActiveFilters) {
            clearSelectedFilters({ country, language });
        }
        Globalize(country, culture, currencyMultiplier);

        renderReact(
            target,
            commonSettings,
            // Since react-redux 8, new development checks were introduced against incorrect usages of useSelector, mostly to detect unnecessary rerenders.
            // These checks were disabled for all existing components as these create quite some issues
            // Ideally these checks should be enabled in all components - UC-1220
            // Notice: Make sure to not add the 'stabilityCheck="never"' in new components
            <ReduxProvider store={store} stabilityCheck="never">
                <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                    <ThemeProvider theme={getTheme(commonSettings)}>
                        <WindowDimensionsProvider>
                            <ModalProvider>
                                <ModelFilter />
                            </ModalProvider>
                        </WindowDimensionsProvider>
                    </ThemeProvider>
                </StyleSheetManager>
            </ReduxProvider>,
        );
    };
